import { render, staticRenderFns } from "./Previewlink.vue?vue&type=template&id=1ee6f0da"
import script from "./Previewlink.vue?vue&type=script&lang=js"
export * from "./Previewlink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports